import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=d09e4e22"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MessageCleaningNeeded: require('/var/www/frontend/components/message/CleaningNeeded.vue').default,MessageAlienationNeeded: require('/var/www/frontend/components/message/AlienationNeeded.vue').default,MessageFederalDone: require('/var/www/frontend/components/message/FederalDone.vue').default,MessageClientWriteAfterCompletion: require('/var/www/frontend/components/message/ClientWriteAfterCompletion.vue').default,MessageActs: require('/var/www/frontend/components/message/Acts.vue').default})
